import axios from 'axios';
import API_HOST from '../api';

const mapQuickSearchApi = function() {
  const api = {};

  api.search = function(query, clientId, userId) {
    let url = `${API_HOST}/api/client/${clientId}`;

    // check if in switch context
    if (typeof userId !== 'undefined') {
      url += `/user/${userId}`;
    }
    
    url += '/geo-search';

    return axios.get(url, {
      params: {
        q: query,
      },
    });
  };

  return api;
};

export default mapQuickSearchApi();
